<script setup lang="ts">
import Sort from '~/components/brands/sort/index.vue';
import { Button } from '@laam/ui/base';
interface BrandCategories {
	l1Categories: {
		id: number;
		title: string;
	}[];
	selectedCategory: {
		id: number;
		title: string;
	};
	activePill: number | undefined;
	sortOptionSelected: string;
	pills: {
		id: number;
		title: string;
		image: string;
		handle: string;
		product_count: number;
		logo: string;
		parent_id: number;
		valhalla_score: number;
		node_level: number;
	}[];
}
defineProps<BrandCategories>();
const emits = defineEmits(['handlel1CategoryClick', 'handlePills']);
</script>

<template>
	<!-- Category Tabs -->
	<div class="flex items-center gap-md border-b border-gray-200">
		<div
			v-for="category in l1Categories"
			:key="category.id"
			class="flex gap-md justify-center items-center py-md px-xl flex-1 hover:cursor-pointer"
			:class="{
				'border-gray-700 border-b-[2px]': selectedCategory.id === category.id,
				'border-gray-200': selectedCategory.id !== category.id,
			}"
			@click="emits('handlel1CategoryClick', category.id, category.title)"
		>
			<p
				class="text-md font-semibold"
				:class="{
					'text-gray-700': selectedCategory.id === category.id,
					'text-gray-500': selectedCategory.id !== category.id,
				}"
			>
				{{ category.title }}
			</p>
		</div>
	</div>

	<!-- Sort and Pills -->
	<div class="flex flex-col justify-center gap-3xl lg:py-3xl">
		<div class="overflow-x-auto w-full no-scrollbar">
			<div class="flex items-center gap-md min-w-max px-2">
				<Sort :sort-option-selected="sortOptionSelected" />

				<!-- Pills -->
				<div
					v-for="item in pills"
					:key="item.id"
					class="cursor-pointer relative text-center text-xs font-medium text-gray-800"
				>
					<Button
						v-if="activePill !== item.id"
						variant="secondary"
						size="sm"
						@click="emits('handlePills', item.id)"
					>
						{{ item.title }}
					</Button>
					<Button
						v-else
						variant="primary"
						size="sm"
						:class="{
							'border-transparent border': activePill === item.id,
						}"
						@click="emits('handlePills', item.id)"
					>
						{{ item.title }}
					</Button>
				</div>
			</div>
		</div>
	</div>
</template>
